import React from 'react';
import './itp-vehicule-utilitare.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import {
  FaShieldAlt,
  FaCheckCircle,
  FaCertificate,
  FaWeightHanging,
  FaWarehouse,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaClipboardCheck,
  FaIdCard,
  FaFileAlt,
  FaFileContract,
  FaFileSignature,
  FaHeadset
} from 'react-icons/fa';

// Imagini specifice scanare și diagnoză computerizată ITP
const images = {
  hero: "https://servicedexcar.ro/wp-content/uploads/2017/03/diagnoza-auto-bucuresti.jpg",
  qualified: "https://images.pexels.com/photos/4489749/pexels-photo-4489749.jpeg",
  zoneServicii: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9Gczcc6inUbxld4jSJGoYZVBTnMQ7lUOOWrfN03rBsEAgw&s",
  zoneAproape: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQsKDqqWM5_lMeia1Pn2RzvlwFcCkISlLTsSjD4JJLBFw&s=10",
  priceN1: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMhbUK6P46YsHMn7T5B7QpbPYQCgObIYqSTRGjAtBjBg&s=10",
  priceN2: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJrDcv1YVMJ6GtHvz80gqIm410KePqnRoASCkbLGf5tQ&s=10",
  priceM3: "https://www.etctrucks.ro/files/home/Stoc%20vehicule/1089/WhatsApp%20Image%202021-03-10%20at%2015.28.37.jpeg",
  priceUtilaje: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGfNZ651gHihsGb8zJR95MJThxbkl_sOZeI32H2-niyg&s=10",
};

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "AutoRepair",
  "name": "Scanare și Diagnoză Computerizată ITP Sector 2",
  "description": "Servicii profesionale de diagnoză auto și scanare computerizată în cadrul stației ITP din Șoseaua Electronicii 24, București.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Șoseaua Electronicii 24",
    "addressLocality": "București",
    "addressRegion": "Sector 2",
    "addressCountry": "RO"
  },
  "areaServed": [
    "Sector 2 București", "Pantelimon", "Colentina", "Obor", "Iancului",
    "Titan", "Vitan", "Baicului", "Fundeni"
  ],
  "priceRange": "RON",
  "telephone": "+40726104358"
};

const ItpScanareComputerizata = () => {
  return (
    <div className="itp-util-layout">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      <Navbar />

      {/* HERO */}
      <section className="util-hero">
        <div className="util-hero-container">
          <div className="util-hero-image-side">
            <img
              src={images.hero}
              alt="Scanare si diagnoza computerizata la ITP Sector 2 - Statia ITP Soseaua Electronicii 24"
              className="util-hero-image"
            />
          </div>
          <div className="util-hero-text-side">
            <span className="itp-eyebrow"> Stație ITP autorizată RAR - Diagnoză Auto</span>
            <h1>Scanare Computerizată ITP Sector 2</h1>
            <p>
              Ai martori aprinși în bord sau vrei să te asiguri că mașina trece testul de noxe? La stația noastră din <strong>ITP Șoseaua Electronicii 24</strong> efectuăm
              <strong> scanare și diagnoză computerizată</strong> profesională pentru identificarea și ștergerea erorilor înainte sau în timpul inspecției tehnice periodice.
            </p>
            <p>
              Stația noastră de <strong>ITP Sector 2 București</strong> este dotată cu testere multimarcă de ultimă generație pentru citirea parametrilor în timp real (emisii, injectoare, EGR, DPF). Deservim rapid clienții din
              <strong> Sector 2</strong> și cartierele vecine: Pantelimon, Colentina, Obor, Iancului, Fundeni și Baicului.
            </p>

            <a href="tel:+40726104358" className="btn-ticket"><FaPhoneAlt /> Programează scanare ITP</a>
          </div>
        </div>
      </section>

      {/* DE CE SĂ NE ALEGI */}
      <section className="util-why-section">
        <div className="util-why-header">
          <span className="itp-eyebrow">Echipamente RAR</span>
          <h2>Gândit pentru conformitate tehnică și siguranță</h2>
          <p>Sistemele electronice moderne necesită o verificare computerizată amănunțită pentru a evita respingerea la linia oficială ITP.</p>
        </div>
        <div className="util-why-grid">
          <div className="util-why-card">
            <div className="util-why-icon"><FaWeightHanging /></div>
            <h3>Scanare parametri OBD</h3>
            <p>Identificăm erorile stocate în calculatorul motorului (ECU) legate de emisiile poluante, conform normelor curente.</p>
          </div>
          <div className="util-why-card">
            <div className="util-why-icon"><FaWarehouse /></div>
            <h3>Locație strategică</h3>
            <p>Suntem poziționați central pe Șoseaua Electronicii 24, facilitând accesul rapid pentru flote corporative și autoturisme private.</p>
          </div>
          <div className="util-why-card">
            <div className="util-why-icon"><FaHeadset /></div>
            <h3>Interpretare tehnică</h3>
            <p>Inspectorii noștri autorizați RAR vă oferă rapoarte clare privind starea componentelor electronice și a sistemelor de siguranță.</p>
          </div>
        </div>
      </section>

      {/* CUM FUNCȚIONEAZĂ */}
      <section className="util-process-section">
        <div className="util-process-header">
          <span className="itp-eyebrow">Simplu și Transparent</span>
          <h2>Cum funcționează procesul de diagnoză computerizată</h2>
          <p>Pregătește-ți autovehiculul pentru ITP în siguranță, urmând pașii noștri de verificare rapidă.</p>
        </div>
        <div className="util-process-grid">
          <div className="util-process-step">
            <div className="util-process-num"><FaPhoneAlt /></div>
            <h3>Faci o programare rapidă</h3>
            <p>Suni direct la stație și soliciți pachetul de verificare tehnică cu scanare inclusă.</p>
          </div>
          <div className="util-process-step">
            <div className="util-process-num"><FaMapMarkerAlt /></div>
            <h3>Vii pe Șos. Electronicii 24</h3>
            <p>Locație accesibilă din zonele Obor, Colentina, Pantelimon și Baicului.</p>
          </div>
          <div className="util-process-step">
            <div className="util-process-num"><FaClipboardCheck /></div>
            <h3>Conectare tester auto</h3>
            <p>Scanăm modulele mașinii și evaluăm emisiile poluante pe loc.</p>
          </div>
          <div className="util-process-step">
            <div className="util-process-num"><FaCertificate /></div>
            <h3>Raport final și ITP</h3>
            <p>Erorile sunt remediate sau interpretate, iar inspecția ta tehnică se validează corect.</p>
          </div>
        </div>
      </section>

      {/* ECHIPĂ CALIFICATĂ */}
      <section className="util-qualified-section">
        <div className="util-qualified-container">
          <div className="util-qualified-image-side">
            <img src={images.qualified} alt="Tester auto conectat pentru diagnoza si scanare computerizata ITP" />
            <div className="util-qualified-badge"><FaShieldAlt /> Testere Omologate</div>
          </div>
          <div className="util-qualified-text-side">
            <h2>Pregătire completă pentru testul de noxe și senzori de siguranță</h2>
            <p>
              Cele mai frecvente respingeri la <strong>ITP București</strong> apar din cauza emisiilor de gaze sau a senzorilor defecți de la frâne sau airbag-uri. Prin serviciul de <strong>scanare computerizată la ITP din Sector 2</strong>, eliminăm incertitudinea.
            </p>
            <ul className="util-checklist">
              <li><FaCheckCircle /> Scanare completă a erorilor active și stocate</li>
              <li><FaCheckCircle /> Monitorizare parametri motor în timp real</li>
              <li><FaCheckCircle /> Diagnosticare preventivă sistem ABS / ESP</li>
              <li><FaCheckCircle /> Verificare funcționare filtru de particule (DPF) și EGR</li>
            </ul>
          </div>
        </div>
      </section>



      {/* ZONE ACOPERITE */}
      <section className="util-zones-section">
        <div className="util-zones-container">
          <div className="util-zone-card">
            <div className="util-zone-image-wrapper">
              <img src={images.zoneServicii} alt="Statie ITP autorizata RAR Soseaua Electronicii" />
            </div>
            <h3>ITP ȘOSEAUA ELECTRONICII 24</h3>
            <p>Suntem stația ta de încredere din <strong>ITP Sector 2</strong>, ușor accesibilă și pentru clienții aflați în căutare de servicii calificate în <strong>Sector 1</strong> sau <strong>Sector 3</strong>.</p>
            <Link to="/" className="util-btn-minimal" style={{ textDecoration: 'none', display: 'inline-block' }}>Citește mai mult</Link>
          </div>
          <div className="util-zone-card">
            <div className="util-zone-image-wrapper">
              <img src={images.zoneAproape} alt="Diagnoza auto si itp aproape de mine Sector 2" />
            </div>
            <h3>DIAGNOZĂ ȘI ITP APROAPE DE MINE</h3>
            <p>Ajungi în doar câteva minute la noi din zonele cheie ale capitalei: <strong>Pantelimon</strong>, <strong>Colentina</strong>, <strong>Obor</strong>, <strong>Iancului</strong> și <strong>Titan</strong>.</p>
            <Link to="/" className="util-btn-minimal" style={{ textDecoration: 'none', display: 'inline-block' }}>Citește mai mult</Link>
          </div>
        </div>
      </section>

      {/* ACTE NECESARE */}
      <section className="util-docs-section">
        <h2>Acte necesare pentru inspecție și scanare computerizată ITP:</h2>
        <div className="util-docs-grid">
          <div className="util-doc-item"><FaFileAlt /><span>Cartea de identitate a vehiculului (CIV)</span></div>
          <div className="util-doc-item"><FaFileContract /><span>Talonul / Certificatul de înmatriculare</span></div>
          <div className="util-doc-item"><FaFileSignature /><span>Asigurarea RCA valabilă</span></div>
          <div className="util-doc-item"><FaIdCard /><span>Actul de identitate (CI) al șoferului</span></div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ItpScanareComputerizata;